module.exports = __webpack_public_path__ + "assets/b52f438763e3f29d69b5895676dae374.png";